<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import './styles/style.less';

export default {
  name: 'App'
};
</script>

<style lang="less" scoped>
#app {
  height: 100%;
}
</style>
